module.exports = __webpack_public_path__ + "img/next-arrow.6f816283.svg";